module.exports = __webpack_public_path__ + "img/sf-footer-icon.74e7732.png";